import React from "react";

const PresentScreenHeroPreviewPlayback = ({ isPlaying, onToggle }) => (
  <button
    type="button"
    className="landing-v2-present-hero__preview-playback"
    aria-label={isPlaying ? "Pause automation preview" : "Play automation preview"}
    aria-pressed={isPlaying}
    onClick={onToggle}
  >
    <i className={`fa-solid ${isPlaying ? "fa-pause" : "fa-play"}`} aria-hidden="true" />
  </button>
);

export default PresentScreenHeroPreviewPlayback;
